module.exports = __webpack_public_path__ + "img/product14.f5b0833e.png";